import React from "react";
import { useI18n } from "../../../i18n/LanguageContext";

const TimePicker = ({ label, name, value, onChange, error }) => {
  const { t } = useI18n();
  const handleChange = ({ target }) => {
    onChange({ name: target.name, value: target.value });
  };
  return (
    <div className="flex flex-col gap-2 p-4 max-w-xs">
      <label className="text-lg font-semibold text-gray-800">{label}</label>
      <input
        type="time"
        name={name}
        value={value}
        onChange={handleChange}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {value && (
        <p className="text-sm text-gray-600">
          {t("time.selected")} <span className="font-bold">{value}</span>
        </p>
      )}
      {error ? (
        <div className="text-red-500 text-sm">{error}</div>
      ) : (
        <div className="m-5"> </div>
      )}
    </div>
  );
};

export default TimePicker;
